export const constants = {
  AIRTABLE: 'MERCURY_AIRTABLE_INTEGRATION_ENABLED',
  ASSIGNATION: 'DRIVER_ASSIGNATION_SECTION',
  ASSIGN_DRIVER: 'MERCURY_DRIVER_ASSIGNATION_ENABLED',
  AUTOMATIC: 'MERCURY_AUTOMATIC_FLOW_ENABLED',
  CANCELLATION_REASONS: 'MERCURY_ARE_CANCELLATION_REASONS_ENABLED',
  CARRIERS_CREATION_ENABLED: 'MERCURY_CARRIERS_CREATION_ENABLED',
  CARRIERS_TAB: 'MERCURY_CARRIERS_MANAGEMENT_ENABLED',
  CARRIER_LITE: 'MERCURY_CARRIER_TAB_LITE_ENABLED',
  CHAT: 'GLOBAL_CHAT_ENABLED',
  COMMUNICATIONS: 'GLOBAL_COMMUNICATIONS_ENABLED',
  CONTAINER_LOAD: 'MERCURY_CONTAINER_LOAD_TYPE_ENABLED',
  CONTRACTS_SECTION: 'MERCURY_DRIVER_ASSIGNATION_SECTION_CONTRACTS_MANAGEMENT_ENABLED',
  CUSTOM_POOL_SECTION: 'MERCURY_DRIVER_ASSIGNATION_SECTION_CUSTOM_POOL_MANAGEMENT_ENABLED',
  CUSTOM_SECTION: 'MERCURY_DRIVER_ASSIGNATION_SECTION_CUSTOM_MANAGEMENT_ENABLED',
  DELEGATION_TAB: 'MERCURY_DELEGATION_MANAGEMENT_ENABLED',
  DISPATCHING_SECTION: 'MERCURY_DISPATCHING_MANAGEMENT_ENABLED',
  DOCS_TAB: 'MERCURY_DOCUMENTATION_MANAGEMENT_ENABLED',
  DRIVER_POSITION_SECTION: 'MERCURY_DRIVER_POSITION_MANAGEMENT_ENABLED', //settings tab
  EDIT_ORDER_DISPATCHING: 'MERCURY_EDIT_ORDER_DISPATCHING_ENABLED',
  EMERGENCIES_BIDS: 'MERCURY_EMERGENCIES_SHOW_BIDS',
  EMERGENCIES_CARRIER_SELECTOR: 'MERCURY_EMERGENCIES_SHOW_CARRIER_SELECTOR_IN_QUOTE',
  EMERGENCIES_SHOW_PRICE_SUGGESTION: 'MERCURY_EMERGENCIES_SHOW_PRICE_SUGGESTION',
  EMERGENCIES_TAB: 'MERCURY_EMERGENCIES_MANAGEMENT_ENABLED',
  FEATURE_AUTOMATIC_FLOW: 'MERCURY_AUTOMATIC_FLOW_ENABLED',
  FEATURE_DEBUG_WARNING: 'MERCURY_DEBUG_WARNING_ON_TOP_ENABLED',
  FILTERS: 'FILTERS',
  FLEET_BUSINESS: 'MERCURY_FLEET_BUSINESS_FILTERS_ENABLED',
  FLEET_JOB_REVIEW: 'MERCURY_FLEET_JOB_REVIEW_FILTERS_ENABLED',
  FLEET_SHIPPER: 'MERCURY_FLEET_SHIPPER_FILTERS_ENABLED',
  FLEET_TAB: 'MERCURY_FLEET_MANAGEMENT_ENABLED',
  FLEET_VEHICLE_TYPE: 'MERCURY_FLEET_VEHICLE_TYPE_FILTERS_ENABLED',
  HEADER_SEARCH_BAR: 'MERCURY_TOP_BAR_SEARCH_BAR_ENABLED',
  ISSUES_TAB: 'MERCURY_ISSUES_MANAGEMENT_ENABLED',
  JOBS_BUSINESS: 'MERCURY_JOBS_BUSINESS_FILTERS_ENABLED',
  JOBS_CANCELLED: 'MERCURY_JOBS_CANCELLED_FILTERS_ENABLED',
  JOBS_CARGO_MANIFEST: 'MERCURY_JOBS_CARGO_MANIFEST_FILTERS_ENABLED',
  JOBS_FTB: 'MERCURY_JOBS_FTB_FILTERS_ENABLED',
  JOBS_MUNICIPALITY: 'MERCURY_JOBS_MUNICIPALITY_FILTERS_ENABLED',
  JOBS_TAB: 'MERCURY_JOBS_MANAGEMENT_ENABLED',
  JOBS_VEHICLE_TYPE: 'MERCURY_JOBS_VEHICLE_TYPE_FILTERS_ENABLED',
  LH_FILTER: 'MERCURY_IS_LH_FILTER_ENABLED',
  MERCURY_UNFREEZE_ENABLED: 'MERCURY_UNFREEZE_ENABLED',
  MY_FLEET_SECTION: 'MERCURY_DRIVER_ASSIGNATION_SECTION_MY_FLEET_MANAGEMENT_ENABLED',
  NETWORK_MONITOR_MODULE_ENABLED: 'NETWORK_MONITOR_MODULE_ENABLED',
  NEW_SHIPPER_ORDER: 'MERCURY_NEW_SHIPPER_ORDER_MANAGEMENT_ENABLED',
  POI: 'MERCURY_POI_INTEGRATION_ENABLED',
  POI_TAB: 'MERCURY_POI_MANAGEMENT_ENABLED',
  POOL_SECTION: 'MERCURY_DRIVER_ASSIGNATION_SECTION_POOL_MANAGEMENT_ENABLED',
  POSTAL_CODES_SECTION: 'MERCURY_POSTAL_CODES_MANAGEMENT_ENABLED', //settings tab
  PREBOOKINGS_SECTION: 'MERCURY_DRIVER_ASSIGNATION_SECTION_PREBOOKINGS_MANAGEMENT_ENABLED',
  PREBOOKINGS_TAB: 'MERCURY_PREBOOKING_MANAGEMENT_ENABLED',
  PREFERENCES_SECTION: 'MERCURY_PREFERENCES_MANAGEMENT_ENABLED', //settings tab
  PRICE_NEGOTATION_PERMISSIONS: 'MERCURY_PRICE_NEGOTIATION_PERMISSIONS',
  QUEUED_TAB: 'MERCURY_QUEUED_ORDERS_MANAGEMENT_ENABLED',
  ROUTING: 'MERCURY_ROUTING_ENABLED',
  SETTINGS_TAB: 'MERCURY_SETTINGS_MANAGEMENT_ENABLED',
  SHIPMENTS_TAB: 'MERCURY_SHIPMENTS_MANAGEMENT_ENABLED',
  SHIPPERS_CONTRACTS_SECTION: 'MERCURY_SHIPPER_CONTRACTS_MANAGEMENT_ENABLED', //settings tab
  SHIPPERS_CREATION_ENABLED: 'MERCURY_SHIPPERS_CREATION_ENABLED',
  SHIPPERS_MINIMALISTIC_FORMS: 'MERCURY_SHIPPERS_MINIMALISTIC_FORMS',
  SHIPPERS_TAB: 'MERCURY_SHIPPERS_MANAGEMENT_ENABLED',
  SIMPLIFIED_SEARCH_BOX: 'MERCURY_SIMPLIFIED_SEARCH_BOX_ENABLED',
  TABS: 'MANAGEMENT',
  TASKS_TAB: 'MERCURY_TASKS_MANAGEMENT_ENABLED',
  TICKET_LIST_ACTIONS_ENABLED: 'MERCURY_TICKET_LIST_ACTIONS_ENABLED',
  TICKET_LIST_ACTIONS_LAUNCH_OFFER_ENABLED: 'MERCURY_TICKET_LIST_ACTIONS_LAUNCH_OFFER_ENABLED',
  TICKET_LIST_ACTIONS_SEND_MESSAGE_ENABLED: 'MERCURY_TICKET_LIST_ACTIONS_SEND_MESSAGE_ENABLED',
  TOP_BAR_MENU_BUTTON_ENABLED: 'TOP_BAR_MENU_BUTTON_ENABLED',
  TOP_BAR_MODULE_ACTIVE_EVALUATION_ENABLED: 'TOP_BAR_MODULE_ACTIVE_EVALUATION_ENABLED',
  TOP_BAR_MODULE_REGION_ENABLED: 'TOP_BAR_MODULE_REGION_ENABLED',
  UNASSIGNED_SECTION: 'MERCURY_UNASSIGNED_JOBS_MANAGEMENT_ENABLED',
  USERS_MANAGEMENT_ENABLED: 'MERCURY_GROUPS_MANAGEMENT_ENABLED',
  USERS_SECTION: 'MERCURY_USERS_MANAGEMENT_ENABLED', //settings tab
  USER_AVAILABILITY: 'MERCURY_USER_AVAILABILITY_ENABLED',
  VEHICLES_TAB: 'MERCURY_VEHICLES_MANAGEMENT_ENABLED',
  WEB_SOCKET: 'MERCURY_WEB_SOCKET_INTEGRATION_ENABLED',
  ZENDESK: 'MERCURY_ZENDESK_INTEGRATION_ENABLED',
  LAST_MILE_MODULE_ENABLED: 'MERCURY_LAST_MILE_MODULE_ENABLED',
  LAST_MILE_SHIPMENTS_ENABLED: 'MERCURY_LAST_MILE_SHIPMENTS_MANAGEMENT_ENABLED',
  LAST_MILE_ISSUES_ENABLED: 'MERCURY_LAST_MILE_ISSUES_MANAGEMENT_ENABLED',
  LAST_MILE_DASHBOARD_ENABLED: 'MERCURY_LAST_MILE_DASHBOARD_MANAGEMENT_ENABLED',
  COPILOT_TAB: 'MERCURY_COPILOT_MANAGEMENT_ENABLED',
  PRICING_CONSOLE_MODULE_ENABLED: 'MERCURY_PRICING_CONSOLE_MANAGEMENT_ENABLED',
};
